<template>
  <div class="my-10">
    <div class="flex flex-col">
      <h1 class="text-3xl text-main-color font-semibold mb-5">{{ brandName }}</h1>
      <div class="grid grid-cols-4 gap-4">
        <template v-if="products.length > 0">
          <router-link
            v-for="item in products"
            :key="item?.id"
            :to="{ name: 'storeProductDetail', params: { id: item?.id } }"
          >
            <StoreProductCard @likeAction="likeAction" :detail="item"> </StoreProductCard>
          </router-link>
        </template>
        <div v-show="products.length === 0 && loading === false">
          <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_products') }}</p>
        </div>
      </div>
      <div v-show="loading === true" class="flex justify-center mt-10" role="status">
        <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color">
        </IconSpinner>

        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconSpinner from '@icons/IconSpinner.vue';
import StoreProductCard from '@cmp/mall/StoreProductCard.vue';
import api from '@/api';
export default {
  name: 'brandProducts',
  components: {
    StoreProductCard,
    IconSpinner,
  },
  data() {
    return {
      loading: false,
      products: [],
      brandQuery: null,
      page: 1,
      count: 0,
      next: null,
    };
  },
  methods: {
    infiniteScroll() {
      let scrollTop = document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 650) {
        if (this.next !== null && this.loading === false) {
          this.page += 1;
          this.getBrandProducts();
        }
      }
    },

    async getBrandProducts() {
      this.loading = true;
      try {
        const response = await api.get('mall/products/', {
          params: {
            brand: this.brandQuery,
            location: this.getLocationId,
            page: this.page,
          },
        });

        const results = response.data.results;
        results.forEach(element => {
          this.products.push(element);
        });

        this.count = response.data.count;
        this.next = response.data.next;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    async likeAction(id, like) {
      if (this.$store.authStatus === false) {
        this.$store.setState('loginModal', true);
        return;
      }

      try {
        await api.post(`mall/products/${id}/like/`, { is_liked: like });
        this.$store.getLiked('mall');
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    brandName() {
      return this.$route.query?.brandName;
    },
    getLocationId() {
      const location = JSON.parse(localStorage.getItem('selectedLocation')) || 1;
      return typeof location === 'object' ? location?.id : location;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.infiniteScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.infiniteScroll);
  },
  async created() {
    this.brandQuery = this.$route.params.id;
    await this.getBrandProducts();
  },
};
</script>

<style scoped></style>
